import React from "react";
import { Row, Col } from "react-bootstrap";
import CustomCard from "../../CustomCard";

import RollUpStand from "../../../../assets/images/FlexPrinting/RollUpStand.png";
import FlexStand from "../../../../assets/images/FlexPrinting/FlexStand.png";

// Card Data
const cardData = [
  { image: RollUpStand, text: "Flex Rollup Stands" },
  { image: FlexStand, text: "Flex Stands" },
];

function HomeSection4() {
  return (
    <>
      <div className="mt-4 w-100 p-0">
        <h2 className="py-4 fw-bold text-center">Flex Printing</h2>

        <Row>
          {/* First row */}
          <Col md={6} className="d-flex">
            <CustomCard image={cardData[0].image} text={cardData[0].text} />
          </Col>
          <Col md={6} className="d-flex">
            <CustomCard image={cardData[1].image} text={cardData[1].text} />
          </Col>
        </Row>
      </div>
    </>
  );
}

export default HomeSection4;
